import CloseIcon from "@mui/icons-material/Close";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import * as React from "react";

import styles from "./Tag.module.css";

export interface TagProps {
  label: string;
  icon?: React.ReactNode;
  onDelete?: () => void;
}

const DEFAULT_ICON = <LocalOfferOutlinedIcon style={{ fontSize: "0.8rem" }} />;

export function Tag({ label, icon = DEFAULT_ICON, onDelete }: TagProps) {
  return (
    <span className={styles.tag}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {label}
      {onDelete && (
        <button
          className={styles.deleteButton}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          aria-label={`Remove ${label}`}
          type="button"
        >
          <CloseIcon style={{ fontSize: "0.625rem" }} />
        </button>
      )}
    </span>
  );
}
